import React from 'react';
import './../index.css';
import Navbar from './navbar';
import { IoIosArrowRoundBack } from "react-icons/io";

export default function PopupContainer({
  children,
  highContrast = false,
  invertColors = false,
  colorBlindFilter = false,
  zoomLevel = 1,
  handleBack,
  screen,
}) {
  return (
    <>
      <div
        className={`popup-wrapper  
          ${highContrast ? 'contrast-on' : ''} 
          ${invertColors ? 'invert-on' : ''} 
          ${colorBlindFilter ? 'cb-filter' : ''}
        `}
      >
        <div
          className={`popup-card
        ${highContrast ? 'contrast-on' : ''} 
          ${invertColors ? 'invert-on' : ''} 
          ${colorBlindFilter ? 'cb-filter' : ''}`}
          style={{
            transform: `scale(${zoomLevel})`,
            transformOrigin: 'top left',
          }}
        >
          <Navbar />
          {children}
        </div>
      </div>
      {screen === 'interaction' && (
        <button type="button" className="back-option" onClick={handleBack}>
          <IoIosArrowRoundBack aria-hidden="true" /> Back
        </button>
      )}
    </>
  );
}
